import { render } from "@testing-library/react";
import React from "react";
import $ from 'jquery';
import ProductService from '../services/product';
import SupplierService from '../services/supplier';
import OrderService from '../services/order';
import SelectedOrder from "../orders/selectedOrder";
import Utility from "../utilities/utility";
import Modal from 'react-bootstrap/Modal';
import placeholder from '../placeholder.png';

class AddOrderProduct extends React.Component {

    constructor() {
        super();

        const queryParams = new URLSearchParams(window.location.search);

        this.state = {
            products: [],
            suppliers: [],
            confirmationProductId: null,
            confirmationProductPrice: null,
            confirmAddProduct: false,
            showImageDialog: false,
            productImages: [],
            selectedProduct : null,
            timeoutId: null
        };

        this.selectedOrder = localStorage.getItem('selectedOrder');

        this.accessLevel = queryParams.get('accessLevel');
    }

    componentDidMount() {

        this.products();
        this.fetchSuppliers();
    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.findProducts();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    async products() {

        try {

            const productList = await ProductService.products();

            this.setState({ products: await productList.json() })
        } catch (error) {

        }

    }

    addToOrder = async (productId, price, confirmed = false) => {

        const orderId = localStorage.getItem('selectedOrder');




        let quantity = $('#product-qty-' + productId).val();


        if (Utility.isEmpty(orderId) || Utility.isEmpty(quantity)) {

            $('#product-row-' + productId).before(
                '<div class="alert alert-danger order-product-alert">Erreur</div>'
            )

            $('.order-product-alert').delay(3000).fadeOut('slow');

            return;
        }

        try {

            const response = await OrderService.addToOrder(orderId, quantity, productId, price, confirmed)

            if (response.status == 409) {


                this.setState({

                    confirmationProductId: productId,
                    confirmationProductPrice: price,
                    confirmAddProduct: true
                });

                return;
            }
            if (response.ok) {

                this.setState({


                    confirmAddProduct: false
                });

                $('#product-qty-' + productId).val('')

                $('#product-row-' + productId).before(

                    '<div class="alert alert-success order-product-alert">Produit Ajouté</div>'
                )

                $('.order-product-alert').delay(3000).fadeOut('slow');
            } else {

                $('#product-row-' + productId).before(

                    '<div class="alert alert-danger order-product-alert">Erreur</div>'
                )

                $('.order-product-alert').delay(3000).fadeOut('slow');
            }

        } catch (error) {

            console.log(error);

            $('#product-row-' + productId).before(

                '<div class="alert alert-danger order-product-alert">Erreur</div>'
            )

            $('.order-product-alert').delay(3000).fadeOut('slow');
        }




    }

    fetchSuppliers = async () => {

        const response = await SupplierService.supplierList();

        this.setState({

            suppliers: await response.json()
        })

    }

    findProducts = async () => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let color = $('#color').val();
        let size = $('#size').val();

        try {

            const response = await ProductService.productList(name, model, brand, size, color);

            if (response.ok) {

                this.setState({
                    products: await response.json()
                })
            }


        } catch (error) {
            console.log(error);
        }

    }

    hideProductConfirmationForm = () => {

        this.setState({

            confirmAddProduct: false
        });
    }

    readdProductToOrder = () => {

        this.addToOrder(this.state.confirmationProductId, this.state.confirmationProductPrice, true);
    }

    fetchProductImages = async (e, product) => {

        e.preventDefault();


        try {

            const response = await ProductService.fetchProductImages(product.id);

            if (response.ok) {

                this.setState({

                    selectedProduct : product,

                    productImages: await response.json(),
                    showImageDialog: true
                })


            }

        } catch (error) {

        }



    }

    closeProductImageDialog = () => {

        this.setState({

                    selectedProduct : null,

                    productImages: null,
                    showImageDialog: false
                })
    }

    render() {

        const { products, productImages, selectedProduct } = this.state;

        console.log(productImages);


        return (

            <div className=" container product-wrapper mt-3">

                <h2 className="mb-3">Ajoute Commande Produits</h2>



                <div className="messageHolder"></div>

                <Modal show={this.state.confirmAddProduct}>
                    <Modal.Header closeButton onHide={this.hideProductConfirmationForm}>Confirme Ajout du Produit</Modal.Header>
                    <Modal.Body>



                        <div className="form-wrapper mt-4">

                            <div className="messageHolder"></div>


                            <div className="form-group">
                                <p className="label text-center">Ce produit a été deja ajouté. Voulez vous ajouter ce produit encore?</p>
                                <button className='btn btn-danger full-width' onClick={this.readdProductToOrder}>Ajoute</button>
                            </div>


                        </div>



                    </Modal.Body>

                </Modal>


                <div className="form-wrapper">
                    <div className="row">
                        <div className="col">


                            <div className="form-group">
                                <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">

                            <div className="form-group">
                                <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="size" placeholder="Numero" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                    </div>




                </div>

                <SelectedOrder orderId={this.selectedOrder} orderService={OrderService} accessLevel={this.accessLevel} />

                <div className="card card-default mt-5 bg-primary text-white">

                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-2">Photo</div>
                            <div className="col-md-4 text-start">Description</div>
                            <div className="col">Prix</div>

                            <div className="col">Quantité</div>
                            <div className="col"></div>

                        </div>
                    </div>
                </div>

                {this.state.showImageDialog && (
                    <div className="image-dialog-overlay" onClick={this.closeProductImageDialog}>
                        <div
                            className="image-dialog"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="dialog-header">
                                <h2>{selectedProduct.name} Images</h2>
                                <button className="close-btn" onClick={this.closeProductImageDialog}>
                                    ×
                                </button>
                            </div>

                            <div className="dialog-images">
                                {productImages && productImages.length > 0 ? (
                                    productImages.map((image, index) => (
                                        <img
                                            key={index}
                                            src={image.fullUrl}
                                            alt={`${selectedProduct.name} ${index + 1}`}
                                            className="dialog-full-image"
                                            onError={(e) => {
                                                e.target.src =
                                                    placeholder;
                                            }}
                                        />
                                    ))
                                ) : (
                                    <p>No images available</p>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {products && products.map(product =>

                    <div className="card card-default mt-2" key={product.id}>

                        <div className="card-body" id={"product-row-" + product.id}>
                            <div className="row">
                                <div className="col">
                                    <img
                                        style={{ width: '200px', height: 'auto' }}
                                        src={product.images ? product.images[0].fullUrl : ''}
                                        alt="Product"
                                        onError={(e) => {
                                            e.target.onerror = null; // prevent infinite loop
                                            e.target.src = placeholder;
                                        }} onClick={(e) => this.fetchProductImages(e, product)}
                                    />
                                </div>
                                <div className="col-md-4 text-start">

                                    <div>{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                                    <div>CPID: {product.supplierUniqueId}</div>
                                    <div>Qté/CARTON: {product.boxQuantity}</div>
                                </div>

                                <div className="col">{product.price}</div>


                                <div className="col">
                                    <div className="form-group">
                                        <input className="form-control" id={"product-qty-" + product.id} placeholder="Quantité" />
                                    </div>

                                </div>
                                <div className="col">
                                    <button className="btn btn-primary full-width-btn" onClick={() => this.addToOrder(product.id, product.price)}>Ajoute</button>

                                </div>
                            </div>
                        </div>
                    </div>

                )
                }





            </div>



        );
    }



}

export default AddOrderProduct;